import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { ErrorType } from 'src/app/enums/error-type.enum';
import {Location} from '@angular/common';

@Component({
  selector: 'fury-covered-items-details',
  templateUrl: './covered-items-details.component.html',
  styleUrls: ['./covered-items-details.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
  encapsulation: ViewEncapsulation.None
})
export class CoveredItemsDetailsComponent implements OnInit {

  itemDetails: any;
  constructor(
    private activatedroute: ActivatedRoute,
    private apiservice: ApiService,
    public location: Location
  ) {
  }

  ngOnInit(): void {
    this.activatedroute.params.subscribe((res: any) => {
      if (res.id) {
        this.getCoveredItemDetails(res.id);
      } else {
        this.location.back();
      }
    });
  }
  getCoveredItemDetails(coveredItemId: string) {
    this.apiservice.get(`admin/plan/covered-item/get-covered-item/${coveredItemId}`).subscribe((res: any) => {
      if (res.body) {
        this.itemDetails = res.body.planCoverItem;
        this.itemDetails.coverageHighlights = this.itemDetails.coverageHighlights ? this.itemDetails.coverageHighlights.split(',') : [];
        this.itemDetails.typeOfSystemWeCover = this.itemDetails.typeOfSystemWeCover ? this.itemDetails.typeOfSystemWeCover.split(',') : [];
        this.itemDetails.followingSystemTypesNotCovered = this.itemDetails.followingSystemTypesNotCovered ? this.itemDetails.followingSystemTypesNotCovered.split(',') : [];

      }
    }, err => {
      this.apiservice.alert(err.error.message, ErrorType.Error);
      this.location.back();
    });
  }

  navigate() {
    this.location.back();
  }

}
